__turbopack_context__.v({
  "body": "InstagramInviteView-module__2chAWq__body",
  "brand": "InstagramInviteView-module__2chAWq__brand",
  "card": "InstagramInviteView-module__2chAWq__card",
  "done": "InstagramInviteView-module__2chAWq__done",
  "error": "InstagramInviteView-module__2chAWq__error",
  "hint": "InstagramInviteView-module__2chAWq__hint",
  "page": "InstagramInviteView-module__2chAWq__page",
  "title": "InstagramInviteView-module__2chAWq__title",
});
